import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row py-3 bt-dash" }
const _hoisted_2 = { class: "col-sm-9 d-flex justify-content-center" }
const _hoisted_3 = { style: {"aspect-ratio":"1 / 1","width":"25%"} }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "img-thumbnail w-100 h-100 d-flex align-items-center justify-content-center",
  style: {"background-color":"#f0f0f0"}
}
const _hoisted_6 = { class: "col-sm-3 d-flex align-items-center" }
const _hoisted_7 = { class: "mb-3 w-100" }
const _hoisted_8 = {
  for: "image-upload",
  class: "form-label"
}
const _hoisted_9 = {
  key: 1,
  style: {"height":"35px"}
}
const _hoisted_10 = { class: "row py-3 bt-dash" }
const _hoisted_11 = { class: "col-sm-9" }
const _hoisted_12 = { class: "f-w-700" }
const _hoisted_13 = {
  class: "color-list-container mt-3",
  style: {"min-height":"320px"}
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "text-white" }
const _hoisted_16 = { class: "col-sm-3 d-flex flex-column" }
const _hoisted_17 = { class: "f-w-700 mb-3" }
const _hoisted_18 = { class: "d-flex flex-column justify-content-between w-100 flex-grow-1" }

import { ref, reactive, onMounted, computed, watch } from 'vue';
import { useProductGroupsStore } from '@/store/management/productGroupsStore';
import { useI18n } from 'vue-i18n'
import { productGroupsAppearanceLanguage } from '@/core/locales/product-groups-language';


export default /*@__PURE__*/_defineComponent({
  __name: 'productGroupsAppearance',
  setup(__props) {

const { t } = useI18n({
  messages: productGroupsAppearanceLanguage
})

const productGroupsStore = useProductGroupsStore();

const compState = reactive({
    imageUrl: '',
    buttonSize: '',
    activeColor: '',
});

const fileInput = ref<HTMLInputElement | null>(null);

const colorList = ref([
    { name: 'Red', color: '#FF0000' },
    { name: 'Green', color: '#00aa00' },
    { name: 'Blue', color: '#0000FF' },
    { name: 'Yellow', color: '#FFFF00' },
    { name: 'Cyan', color: '#00FFFF' },
    { name: 'Magenta', color: '#FF00FF' },
    { name: 'Orange', color: '#FFA500' },
    { name: 'Purple', color: '#800080' },
    { name: 'Brown', color: '#A52A2A' },
    { name: 'Pink', color: '#FFC0CB' },
    { name: 'Lime', color: '#32cd32' },
    { name: 'Teal', color: '#008080' },
]);

const activeProductGroup = computed(() => {
    return productGroupsStore.getActiveProductGroup
})

const tempActiveProductGroup = computed(() => {
    return productGroupsStore.getTempActiveProductGroup
})

const activeProductGroupId = computed(() => {
    return productGroupsStore.getActiveProductGroupId
})

onMounted(() => {
    if (tempActiveProductGroup.value?.id) {
        compState.imageUrl = tempActiveProductGroup.value?.appearance?.image || '';
        compState.buttonSize = tempActiveProductGroup.value?.appearance?.fontSizes || '';
        compState.activeColor = tempActiveProductGroup.value?.appearance?.buttonColor || '';
    }
    console.log('tempActiveDepartment', tempActiveProductGroup.value);

});

watch(activeProductGroupId, (newVal) => {
    if (newVal) {
        const department = activeProductGroup.value
        compState.imageUrl = department.appearance.image;
        compState.buttonSize = department.appearance.fontSizes;
        compState.activeColor = department.appearance.buttonColor;
        if (fileInput.value) {
            fileInput.value.value = '';
        }
    }
});

watch(compState, (newVal) => {
    productGroupsStore.setTempActiveProductGroup({
        ...tempActiveProductGroup.value,
        appearance: {
            image: compState.imageUrl,
            buttonColor: compState.activeColor,
            fontSizes: compState.buttonSize,
        }
    });
}, { deep: true });

function previewImage(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
        const reader = new FileReader();
        reader.onload = async (e: ProgressEvent<FileReader>) => {
            const imageData = e.target?.result;
            if (imageData) {
                const compressedImage = await compressImage(file);
                compState.imageUrl = compressedImage as string;
            }
        };
        reader.onerror = (error) => {
            console.error('Error reading file:', error);
        };
        reader.readAsDataURL(file);
    } else {
        compState.imageUrl = '';
    }
}

function compressImage(imageFile: File): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event: ProgressEvent<FileReader>) => {
            const img = new window.Image();
            img.onload = () => {
                let width = img.width;
                let height = img.height;
                const maxSize = 800;
                if (width > maxSize || height > maxSize) {
                    if (width > height) {
                        height = Math.round((height * maxSize) / width);
                        width = maxSize;
                    } else {
                        width = Math.round((width * maxSize) / height);
                        height = maxSize;
                    }
                }
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                if (!ctx) {
                    reject(new Error('Canvas context not available'));
                    return;
                }
                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(img, 0, 0, width, height);
                const quality = imageFile.size > 1000000 ? 0.7 : 0.95;
                const compressedImageData = canvas.toDataURL('image/jpeg', quality);
                resolve(compressedImageData);
            };
            img.onerror = reject;
            img.src = event.target?.result as string;
        };
        reader.onerror = reject;
        reader.readAsDataURL(imageFile);
    });
}

function removeImage() {
    compState.imageUrl = '';
    if (fileInput.value) {
        fileInput.value.value = '';
    }
}
function setFontSize(size: string) {
    compState.buttonSize = size;
}
function onColorClick(id: string) {
    compState.activeColor = id;
    const updated = {
        ...activeProductGroup.value,
        appearance: {
            ...activeProductGroup.value.appearance,
            buttonColor: id,
        }
    };
    const index = productGroupsStore.productGroupList.findIndex(
        (d) => d.id === activeProductGroup.value.id
    );
    if (index !== -1) {
        productGroupsStore.productGroupList[index] = updated;
    }
    productGroupsStore.setTempActiveProductGroup(updated);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (compState.imageUrl)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: compState.imageUrl,
                alt: "Image Preview",
                class: "img-thumbnail w-100 h-100 object-fit-cover"
              }, null, 8, _hoisted_4))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('NoImage')), 1)
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(t)('UploadImage')), 1),
          _createElementVNode("input", {
            class: "form-control mb-3",
            type: "file",
            id: "image-upload",
            onChange: previewImage,
            ref_key: "fileInput",
            ref: fileInput
          }, null, 544),
          (compState.imageUrl)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-danger w-100",
                onClick: removeImage
              }, _toDisplayString(_unref(t)('RemoveImage')), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_9))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("h6", _hoisted_12, _toDisplayString(_unref(t)('ButtonColor')), 1),
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colorList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "text-center py-2 rounded-3 hover-pointer card mb-0 d-flex flex-column justify-content-center align-items-center",
              style: _normalizeStyle([{"height":"96px"}, {
                        backgroundColor: item.color, gridColumn: 'span 1 / span 1',
                        boxShadow: compState.activeColor === item.color ? 'inset 0 0 16px rgba(0, 0, 0, 0.7)' : 'none'
                    }]),
              onClick: ($event: any) => (onColorClick(item.color)),
              key: item.color
            }, [
              _createElementVNode("h5", _hoisted_15, _toDisplayString(_unref(t)(item.name)), 1)
            ], 12, _hoisted_14))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("h6", _hoisted_17, _toDisplayString(_unref(t)('ButtonFontSize')), 1),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-outline-primary w-100 py-3", { ' btn-primary': compState.buttonSize === 'X-Large' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setFontSize('X-Large'))),
            style: {"font-size":"1.5rem"}
          }, _toDisplayString(_unref(t)('XLarge')), 3),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-outline-primary w-100 py-3", { ' btn-primary': compState.buttonSize === 'Large' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setFontSize('Large'))),
            style: {"font-size":"1.25rem"}
          }, _toDisplayString(_unref(t)('Large')), 3),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-outline-primary w-100 py-3", { ' btn-primary': compState.buttonSize === 'Medium' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (setFontSize('Medium'))),
            style: {"font-size":"1rem"}
          }, _toDisplayString(_unref(t)('Medium')), 3),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-outline-primary w-100 py-3", { ' btn-primary': compState.buttonSize === 'Small' }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (setFontSize('Small'))),
            style: {"font-size":"0.875rem"}
          }, _toDisplayString(_unref(t)('Small')), 3)
        ])
      ])
    ])
  ], 64))
}
}

})